import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

// The canonical PRODUCTION brand origin (Story 53.7 / EO-335). Deliberately the
// same in every build, like index.html's og:url: on dev/stage it marks those
// hosts as copies of the production site rather than as sites of their own.
export const CANONICAL_ORIGIN = 'https://ianua.emjo-consulting.dk';

// Keeps ONE <link rel="canonical"> naming the current page on the canonical
// origin. It cannot live in index.html: the SPA serves that file for every path,
// so a static tag would declare every docs page a duplicate of the homepage.
// Query and fragment are dropped — they select state within a page, not a page.
@Injectable({ providedIn: 'root' })
export class CanonicalLinkService {
  private readonly doc = inject(DOCUMENT);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  start(): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
      .subscribe(e => this.set(e.urlAfterRedirects));
  }

  private set(url: string): void {
    const path = url.split(/[?#]/, 1)[0] || '/';
    let link = this.doc.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = this.doc.createElement('link');
      link.rel = 'canonical';
      this.doc.head.appendChild(link);
    }
    link.href = CANONICAL_ORIGIN + path;
  }
}
